function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { getPlatform as o } from "./utils/platform.js";
import N from "./fade-in.js";
import { useTheme as v, useAriaId as M } from "./hooks.js";
import { spinnerIos as g, spinnerIosSvgPath as t, spinnerDefault as z, spinnerDefaultPath as u } from "./spinner.css-mistica.js";
import { vars as x } from "./skins/skin-contract.css-mistica.js";
import { jsxs as n, jsx as l } from "./_virtual/jsx-runtime.js";
const j = (param)=>{
    let { color: e , delay: a = "500ms" , size: s = 24 , style: r , rolePresentation: h  } = param;
    const { texts: p , platformOverrides: f  } = v();
    e = e || x.colors.controlActivated;
    const i = M(), c = !h, m = p.loading, d = o(f) === "ios" ? /* @__PURE__ */ n("svg", {
        "aria-labelledby": i,
        className: g,
        height: s,
        style: _objectSpread({}, r),
        role: "img",
        viewBox: "0 0 28 28",
        width: s,
        children: [
            c && /* @__PURE__ */ l("title", {
                id: i,
                children: m
            }),
            /* @__PURE__ */ n("g", {
                role: "presentation",
                children: [
                    /* @__PURE__ */ l("path", {
                        className: t,
                        fill: e,
                        d: "M18.696 10.5c-.275-.48-.113-1.09.365-1.367l4.76-2.75c.49-.274 1.1-.11 1.37.367.28.48.12 1.092-.36 1.364l-4.76 2.75c-.48.277-1.09.113-1.36-.364z"
                    }),
                    /* @__PURE__ */ l("path", {
                        className: t,
                        fill: e,
                        d: "M16.133 6.938l2.75-4.765c.276-.478.89-.643 1.367-.366.48.276.64.886.365 1.366l-2.748 4.762c-.276.48-.888.645-1.367.368-.48-.276-.644-.89-.367-1.365z"
                    }),
                    /* @__PURE__ */ l("path", {
                        className: t,
                        fill: e,
                        d: "M13.5 7.5c-.553 0-1-.448-1-1V1c0-.554.447-1 1-1 .553 0 1.002.447 1.002 1v5.5c-.002.553-.45 1-1.003 1z"
                    }),
                    /* @__PURE__ */ l("path", {
                        className: t,
                        fill: e,
                        d: "M8.303 10.5c-.277.477-.888.64-1.365.365l-4.763-2.75c-.478-.273-.643-.886-.367-1.365.277-.48.89-.642 1.367-.368l4.762 2.75c.48.278.643.89.366 1.368z"
                    }),
                    /* @__PURE__ */ l("path", {
                        className: t,
                        fill: e,
                        d: "M9.133 7.937l-2.75-4.763c-.276-.48-.11-1.09.365-1.366.48-.277 1.09-.114 1.367.366l2.75 4.765c.274.47.112 1.08-.367 1.36-.477.28-1.09.11-1.365-.37z"
                    }),
                    /* @__PURE__ */ l("path", {
                        className: t,
                        fill: e,
                        d: "M6.5 14.5H1c-.554 0-1-.448-1-1 0-.554.447-1 1-1h5.5c.55 0 1 .447 1 1 0 .552-.448 1-1 1z"
                    }),
                    /* @__PURE__ */ l("path", {
                        className: t,
                        fill: e,
                        d: "M8.303 16.502c.277.478.113 1.088-.365 1.366l-4.762 2.75c-.478.272-1.09.11-1.368-.367-.276-.47-.11-1.08.367-1.36l4.762-2.75c.478-.28 1.09-.11 1.366.37z"
                    }),
                    /* @__PURE__ */ l("path", {
                        className: t,
                        fill: e,
                        d: "M10.866 20.062l-2.75 4.767c-.277.47-.89.63-1.367.36-.48-.28-.65-.89-.37-1.37l2.75-4.77c.27-.48.89-.64 1.36-.37.47.276.64.89.36 1.364z"
                    }),
                    /* @__PURE__ */ l("path", {
                        className: t,
                        fill: e,
                        d: "M13.5 19.502c.553 0 1.002.448 1.002 1.002v5.498c0 .55-.448 1-1.003 1-.56 0-1-.448-1-1v-5.498c0-.554.44-1.002 1-1.002z"
                    }),
                    /* @__PURE__ */ l("path", {
                        className: t,
                        fill: e,
                        d: "M17.867 19.062l2.748 4.764c.275.48.113 1.088-.365 1.365-.48.28-1.09.12-1.367-.36l-2.75-4.76c-.276-.47-.11-1.09.367-1.36.48-.27 1.09-.11 1.367.37z"
                    }),
                    /* @__PURE__ */ l("path", {
                        className: t,
                        fill: e,
                        d: "M18.696 16.502c.276-.48.887-.646 1.365-.367l4.77 2.748c.48.28.64.89.37 1.368-.27.48-.88.64-1.37.37l-4.76-2.75c-.47-.27-.64-.89-.36-1.36z"
                    }),
                    /* @__PURE__ */ l("path", {
                        className: t,
                        fill: e,
                        d: "M25.998 12.5h-5.5c-.553 0-1.002.447-1.002 1 0 .552.447 1 1 1H26c.554 0 1.002-.448 1.002-1 0-.554-.448-1-1.002-1z"
                    })
                ]
            })
        ]
    }) : /* @__PURE__ */ n("svg", {
        "aria-labelledby": c ? i : void 0,
        className: z,
        height: s,
        style: _objectSpread({}, r),
        role: "img",
        viewBox: "0 0 66 66",
        width: s,
        children: [
            c && /* @__PURE__ */ l("title", {
                id: i,
                children: m
            }),
            /* @__PURE__ */ l("circle", {
                className: u,
                cx: "33",
                cy: "33",
                fill: "none",
                r: "30",
                role: "presentation",
                stroke: e,
                strokeWidth: "6"
            })
        ]
    });
    return a === "0" || a === "0s" || a === "0ms" ? d : /* @__PURE__ */ l(N, {
        delay: a,
        dataAttributes: {
            "component-name": "Spinner"
        },
        children: d
    });
};
export { j as default };
